import styled from "styled-components";
export const ReviewerWrapper = styled.div`
.reviewList{
    display: flex;
    gap:10px;
    flex-wrap: wrap;
}
.reviewCard{
    padding: 4%;
    display: flex;
    border: 1px solid #b6b6b6;
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    margin: 2% 0;
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    cursor: pointer;
}
.reviewCard:hover {
    box-shadow: 0 5px 10px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
  }
  .reviewCard p{
    font-size: 14px;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
  }
`;